"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSvg = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _context = require("../context");
var _propTypes = require("../prop-types");
var _screenReaderOnly = require("../screen-reader-only");
var _utils = require("../utils");
var _interfaces = require("./interfaces");
var _core = require("@emotion/core");
var _excluded = ["theme"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Svg = (0, _context.styledWithTheme)('svg')(function (_ref) {
  var theme = _ref.theme,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var selectors = theme.selectors;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _utils.cssValueProp)(selectors.colorOrNull, props.color, 'color')), (0, _utils.cssValueProp)(selectors.colorOrNull, props.backgroundColor, 'backgroundColor')), (0, _utils.getPropsStyles)(['alignSelf', 'display'], props)), (0, _utils.getSpacingStyles)(['margin'], props, selectors.space)), {}, {
    flexShrink: 0
  });
});
var createBackgroundImageMixin = function createBackgroundImageMixin(_ref2) {
  var width = _ref2.width,
    height = _ref2.height,
    paths = _ref2.paths;
  var style = "width: ".concat((0, _utils.px)(width), "; height: ").concat((0, _utils.px)(height), ";");
  var mixin = function mixin(_ref3) {
    var theme = _ref3.theme,
      color = _ref3.color;
    return "url(\"data:image/svg+xml,".concat(encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' viewBox='0 0 ").concat(width, " ").concat(height, "' style='").concat(style, "'>").concat(paths.map(function (path) {
      return "<path fill='".concat(theme.selectors.colorOrNull(color), "' fill-rule='evenodd' d='").concat(path, "'></path>");
    }).join(''), "</svg>")), "\")");
  };
  return mixin;
};
var getSvgFromAttributes = function getSvgFromAttributes(attributes, size) {
  switch (attributes.kind) {
    case 'SVGIcon':
      return attributes.getAttributes();
    case 'SVGIconWithSizes':
      return attributes.getAttributes(size);
    default:
      throw new Error('Unsupported data object passed as icon data');
  }
};
var createSvg = function createSvg(displayName, attributes) {
  var Component = function Component(_ref4) {
    var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? _interfaces.IconSize.Small : _ref4$size,
      _ref4$display = _ref4.display,
      display = _ref4$display === void 0 ? 'block' : _ref4$display,
      color = _ref4.color,
      margin = _ref4.margin,
      backgroundColor = _ref4.backgroundColor,
      title = _ref4.title,
      ariaHidden = _ref4['aria-hidden'],
      dataTestId = _ref4.dataTestId,
      RtlIcon = _ref4.rtl;
    var _useContext = (0, _react.useContext)(_context.StencilContext),
      isRTL = _useContext.isRTL;
    var hasTitle = !!title && !!title.trim().length;
    var isAccessible = hasTitle || ariaHidden;
    if ((0, _utils.envIsDevelopment)() && !isAccessible) {
      console.warn("For accessibility, icons should either have a 'title' or use 'aria-hidden={true}'. Check the icon with data-test-flagged='".concat(_utils.MISSING_ALT_TEXT_TEST_FLAG, "'."));
    }
    var shouldAnnounceTitle = hasTitle && (!ariaHidden || ariaHidden === 'false');
    var dataTestProps = (0, _utils.buildDataTestProps)({
      dataTestComponent: "Stencil".concat(displayName),
      dataTestId: dataTestId
    });
    var dataProps = isAccessible ? dataTestProps : _objectSpread(_objectSpread({}, dataTestProps), {}, {
      'data-test-flagged': _utils.MISSING_ALT_TEXT_TEST_FLAG
    });
    var _getSvgFromAttributes = getSvgFromAttributes(attributes, size),
      paths = _getSvgFromAttributes.paths,
      params = _getSvgFromAttributes.params,
      width = _getSvgFromAttributes.width,
      height = _getSvgFromAttributes.height;
    var pathStrokeParamsKeys = Object.keys(params).filter(function (key) {
      return key.match(/^stroke-*/);
    });
    var pathStrokeParams = pathStrokeParamsKeys.reduce(function (out, key) {
      return _objectSpread(_objectSpread({}, out), {}, (0, _defineProperty2.default)({}, key.replace(/-./g, function (x) {
        return x[1].toUpperCase();
      }), params[key]));
    }, {});
    return (0, _core.jsx)(_react.default.Fragment, null, RtlIcon && isRTL ? (0, _core.jsx)(RtlIcon, {
      size: size,
      display: display,
      color: color,
      margin: margin,
      backgroundColor: backgroundColor,
      title: title,
      'aria-hidden': ariaHidden,
      dataTestId: dataTestId
    }) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(Svg, (0, _extends2.default)({
      color: color,
      display: display,
      xmlns: "http://www.w3.org/2000/svg",
      className: "stencilSvgIcon",
      width: width,
      height: height,
      margin: margin,
      "aria-hidden": true,
      focusable: "false",
      backgroundColor: backgroundColor,
      style: {
        width: width,
        height: height,
        transform: 'translate3d(0px, 0px, 0px)',
        backgroundClip: 'content-box, padding-box',
        overflow: 'visible'
      },
      viewBox: "0 0 ".concat(width, " ").concat(height)
    }, dataProps, (0, _utils.omit)(params, pathStrokeParamsKeys)), paths.map(function (d, i) {
      return (0, _core.jsx)("path", (0, _extends2.default)({
        d: d,
        fill: "currentColor",
        fillRule: "evenodd",
        key: "path".concat(i)
      }, pathStrokeParams));
    })), shouldAnnounceTitle ? (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, title) : undefined));
  };
  Component.displayName = displayName;
  Component.defaultProps = {
    display: 'block'
  };
  Component.getBackgroundImage = function (_ref5) {
    var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? _interfaces.IconSize.Small : _ref5$size,
      theme = _ref5.theme,
      color = _ref5.color;
    var _getSvgFromAttributes2 = getSvgFromAttributes(attributes, size),
      paths = _getSvgFromAttributes2.paths,
      width = _getSvgFromAttributes2.width,
      height = _getSvgFromAttributes2.height;
    return createBackgroundImageMixin({
      width: width,
      height: height,
      paths: paths
    })({
      theme: theme,
      color: color
    });
  };
  var ComponentWithDocs = (0, _stencilReactDesc.describe)(Component).description("".concat(displayName, " icon."));
  ComponentWithDocs.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.alignSelfPropTypes), _propTypes.backgroundColorPropTypes), _propTypes.colorPropTypes), _propTypes.displayPropTypes), _propTypes.marginPropTypes), {}, {
    title: _stencilReactDesc.PropTypes.string.description('Used as alt text for the icon for screen readers. Leave blank if the icon is purely presentational.'),
    size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.IconSize)).description('Determines the size of the icon.'),
    dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
  });
  return Component;
};
exports.createSvg = createSvg;